import { useEffect, useRef, useState } from "react";
import NewButton from "./newButton";
import { ButtonTypes } from "../../Definitions";
import { colors, frames } from "../../Styles";

interface DraggableButtonProps {
  content: string;
  startEnhancer: string | JSX.Element;
  onClick: () => void;
  disabled: boolean;
  startPosition?: number;
  maxTop?: number;
  gridArea?: string;
}

const DraggableButton = ({ content, startEnhancer, onClick, disabled, gridArea, startPosition = 180, maxTop = 10 }: DraggableButtonProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLDivElement | null>(null);

  const [yPercent, setYPercent] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [startY, setStartY] = useState(0);

  const getBottomPx = () => {
    if (!containerRef.current || !buttonRef.current) return startPosition;

    const containerHeight = containerRef.current.offsetHeight;
    const btnWidth = buttonRef.current.offsetWidth; 
    const minBottom = btnWidth + 10;            
    const maxBottom = containerHeight - maxTop;
    console.log(btnWidth)
    return minBottom + yPercent * (maxBottom - minBottom);
  };

  // Initial position
  useEffect(() => {
    if (!containerRef.current || !buttonRef.current) return;

    const containerHeight = containerRef.current.offsetHeight;
    const btnWidth = buttonRef.current.offsetWidth;
    const minBottom = btnWidth + 10;
    const maxBottom = containerHeight - maxTop;

    const clamped = Math.min(Math.max(startPosition, minBottom), maxBottom);
    setYPercent((clamped - minBottom) / (maxBottom - minBottom));
  }, [startPosition, maxTop]);

  // Dragging effect
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!dragging || !containerRef.current || !buttonRef.current) return;

      const deltaY = startY - e.clientY;
      const containerHeight = containerRef.current.offsetHeight;
      const btnWidth = buttonRef.current.offsetWidth;
      const minBottom = btnWidth + 10;
      const maxBottom = containerHeight - maxTop;

      let newBottom = getBottomPx() + deltaY;
      newBottom = Math.min(Math.max(newBottom, minBottom), maxBottom);

      setYPercent((newBottom - minBottom) / (maxBottom - minBottom));
      setStartY(e.clientY);
    };

    const handleMouseUp = () => setDragging(false);

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, startY, yPercent, maxTop]);

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%", height: "100%", overflow: "hidden", gridArea }}>
      <frames._grid_bluePrintButton_container
        ref={buttonRef}
        onMouseDown={(e) => { setDragging(true); setStartY(e.clientY) }}
        style={{ bottom: `${getBottomPx()}px` }}
      >
        <NewButton
          content={content}
          startEnhancer={startEnhancer}
          buttonType={ButtonTypes.textButton}
          overrides={{
            baseStyles: {
              backgroundColor: colors.greyPrimary,
              padding: "6px 8px",
              borderRadius: "8px 8px 0 0",
              userSelect: "none",
              height: "fit-content",
            },
            hoverStyles: { backgroundColor: colors.greySecondary, opacity: "1" },
            startEnhancerStyles: { transform: "rotate(-45deg)" },
          }}
          onClick={onClick}
          disabled={disabled}
        />
      </frames._grid_bluePrintButton_container>
    </div>
  );
};

export default DraggableButton;
